import React, { useCallback, useState } from "react";
import Button, { ButtonProps } from "./Button";
import { Modal } from "@mui/material";
import ConfirmModal from "./ConfirmModal";

interface Props {
    children?: string;
    onCancel?: () => void;
    onConfirm?: (close: () => void, setLoading: (val: boolean) => void) => void;
    title?: string;
    cancelText?: string;
    confirmText?: string;
    button: ButtonProps;
}

const ConfirmButton = (props: Props) => {
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    const { children, button, title, cancelText, confirmText } = props;

    const onCancel = useCallback(() => {
        setOpen(false);
        props.onCancel?.();
    }, [props]);

    const onConfirm = useCallback(() => {
        props.onConfirm?.(() => setOpen(false), setLoading);
    }, [props]);

    return (
        <>
            <Button
                {...button}
                children={children}
                onClick={() => setOpen(true)}
            />
            <Modal open={open} onClose={() => {}}>
                <ConfirmModal
                    onCancel={onCancel}
                    onConfirm={onConfirm}
                    title={title}
                    cancelText={cancelText}
                    confirmText={confirmText}
                    loading={loading}
                />
            </Modal>
        </>
    );
};

export default ConfirmButton;
